import { useState } from "react";

import { endpoints, type Alert } from "../../services/api";

type Props = {
  alerts: Alert[];
  onChange: (alerts: Alert[]) => void;
};

const SEVERITY_CLASS: Record<Alert["severity"], string> = {
  CRITICAL: "alert--critical",
  WARNING: "alert--warning",
  INFO: "alert--info",
};

const TYPE_LABEL: Record<Alert["type"], string> = {
  DEAD_STOCK: "Leżak",
  LOW_MARGIN_BESTSELLER: "Niska marża",
  HIGH_AFFINITY_OPPORTUNITY: "Możliwość",
  STOCKOUT_RISK: "Kończy się",
  VELOCITY_SPIKE: "Trend",
  SEASONAL_OPPORTUNITY: "Sezon",
  ANOMALY: "Anomalia",
};

export default function AlertsList({ alerts, onChange }: Props) {
  const [busy, setBusy] = useState<number | null>(null);

  if (alerts.length === 0) {
    return (
      <section className="card">
        <h2 className="card__title">📋 Dziś do zrobienia</h2>
        <div className="alerts__empty">
          Brak otwartych alertów — wgraj świeży raport, żeby BasketBooster znalazł nowe szanse.
        </div>
      </section>
    );
  }

  const handleDone = async (alertId: number) => {
    setBusy(alertId);
    try {
      await endpoints.markAlertRead(alertId);
      onChange(alerts.filter((a) => a.id !== alertId));
    } catch {
      // jeśli się nie uda, zostawiamy alert w UI — kolejna próba przy click
    } finally {
      setBusy(null);
    }
  };

  return (
    <section className="card">
      <h2 className="card__title">📋 Dziś do zrobienia</h2>
      <ul className="alerts">
        {alerts.map((a) => (
          <li key={a.id} className={`alert ${SEVERITY_CLASS[a.severity]}`}>
            <div className="alert__head">
              <span className="alert__title">{a.title}</span>
              <span style={{ fontSize: "0.8rem", opacity: 0.75 }}>
                {TYPE_LABEL[a.type]}
              </span>
            </div>
            <div className="alert__body">{a.body}</div>
            <button
              className="alert__action"
              onClick={() => handleDone(a.id)}
              disabled={busy === a.id}
            >
              {busy === a.id ? "Zapisuję…" : "Zrobione ✓"}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
